import script from "./listing-points-cost-input.vue?vue&type=script&setup=true&lang=js"
export * from "./listing-points-cost-input.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__